import { render, staticRenderFns } from "./EstablecimientoSalud.vue?vue&type=template&id=1be75639&scoped=true"
import script from "./EstablecimientoSalud.vue?vue&type=script&lang=js"
export * from "./EstablecimientoSalud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be75639",
  null
  
)

export default component.exports